export default __webpack_public_path__ + "static/media/kiwi.a4983a59.png";